module.exports = __webpack_public_path__ + "img/toolsPanel.88316d6a.png";